import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {SnackBarService} from "../../@core/services/snack-bar.service";
import {IFreeCase} from "../../@modules/+search-user/user-content/services/interfaces/free-cases.interface";


@Injectable({
  providedIn: 'root'
})
export class FreeCasesService {

  constructor(private readonly http: HttpClient, private sb: SnackBarService) {
  }

  public getFreeCases(): Observable<IFreeCase[]> {
    return this.http.get<IFreeCase[]>(`${environment.GATEWAY_URL}/cases`)
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }


  private onHandleError(error: HttpErrorResponse): Observable<any> {
    const message = error.error.statusCode + ' ' + (error.error.message || error.error.error);
    this.sb.openSnackBar(message, 3000, 'error');
    return of();
  }
}
